<template>
  <v-btn
    @click="toggleMusicVolume"
    :class="buttonTextColor"
    :color="buttonColor"
  >
    <v-icon class="mr-1">volume_down</v-icon>
    {{ dropVolume ? 'End Announcement' : 'Announce' }}
  </v-btn>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'ToggleMusicVolumeButton',
  data() {
    return {
      dropVolume: false,
    };
  },
  computed: {
    buttonColor() {
      return this.dropVolume ? 'warning' : 'secondary';
    },
    buttonTextColor() {
      return this.dropVolume ? 'light--text' : 'appMain--text';
    },
  },
  methods: {
    toggleMusicVolume: debounce(function () {
      this.dropVolume = !this.dropVolume;

      this.$emit('sendAction', {
        type: 'ActionDropMusicVolume',
        dropVolume: this.dropVolume,
      });
    }, 100),
  },
};
</script>
